import { LearningResource } from './learning_resource.model';
import { User } from './user.model';

export interface LearningResourceEnrollment {
  id: number;
  user_id: number;
  learning_resource_id: number;
  start_date: string;
  end_date: string | null;
  user?: User;
  learning_resource?: LearningResource;
  time_registered_in_seconds?: number;
}

export interface LearningResourceEnrollmentSerialized extends LearningResourceEnrollment {
  resource_name: string;
  is_active: boolean;
  formation_hours_label: string;
}

export function isActiveLearningResourceEnrollment(
  enrollment: LearningResourceEnrollment | null | undefined
): enrollment is LearningResourceEnrollment {
  return enrollment?.id != null && enrollment.end_date == null;
}
